import React from 'react'
import { css } from '@emotion/core'
import { colors, Paragraph } from '@fs/zion-ui'

const sg = `${colors.green05}`
const eg = `${colors.green20}`

const lightenText = css`
  color: ${colors.gray30};
`

export default function ProgressBar({
  total,
  completed,
  caption,
  startGradient = sg,
  endGradient = eg,
  maxWidth = 500,
}) {
  const completedNumber = parseInt(completed, 10) || 0
  const totalNumber = parseInt(total, 10) || 0
  const resolvedWidth =
    completedNumber === 0 || totalNumber === 0 ? 0 : Math.floor((completedNumber / totalNumber) * maxWidth)

  const styles = {
    statusBar: css`
      height: 10px;
      max-width: ${maxWidth}px;
      border-radius: 10px;
    `,
    totalBar: css`
      background-color: ${colors.gray10};
    `,
    completedBar: css`
      background-image: linear-gradient(90deg, ${startGradient}, ${endGradient});
      width: ${resolvedWidth}px;
    `,
  }

  return (
    <>
      <div css={[styles.statusBar, styles.totalBar]}>
        <div css={[styles.statusBar, styles.completedBar]} />
      </div>
      <div css={lightenText}>
        <Paragraph size="xs">{caption}</Paragraph>
      </div>
    </>
  )
}
